<template>
    <!-- 表格排序组件 -->
    <div class="table_sort noselect_text" @click="changeStatus">
        <span>{{label}}</span>
        <div class="sort_icon">
            <i class="el-icon-caret-top" :class="{active: status == 'asc'}"/>
            <i class="el-icon-caret-bottom" :class="{active: status == 'desc'}"/>
        </div>
        
    </div>
</template>

<script>
    export default {
        model: {
            prop: "status"
        },
        props: {
            // 排序状态   desc 降序   asc 升序
            status: {
                type: String,
                default: 0,
            },
            label: {
                type: String,
                default: ""
            }
        },
        methods: {
            // 改变状态
            changeStatus() {
                let statusVal = "desc";
                if(this.status == "desc") statusVal = "asc";
                this.$emit("input",statusVal);
                this.$emit("change",statusVal);
            }
        }
    }
</script>

<style lang="scss" scoped>
.table_sort {
    display: flex;
    align-items: center; 
    cursor: pointer;
    >span {
        cursor: pointer; 
    }      
    .sort_icon {
        width: 13px;
        height: 26px;
        font-size: 13px;
        color: #c0c4cc;
        padding: 0 5px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        >i {
            cursor: pointer; 
            &::before {
                position: relative;
            }
            &:nth-child(1) {
                &::before {
                    top: 3px;
                }
            }
            &:nth-child(2) {
                &::before {
                    top: -3px;
                }
            }
        }
        .active {
            color: #525F7F;
        }
    }
    
}
</style>


// WEBPACK FOOTER //
// src/pages/components/TableSort.vue